import { MiniappTopbar } from './MiniappTopbar'
import { useTopbar } from '@/features/topbar/logic/useTopbar'
import { useBreakpoint } from '@/ui/utils/useBreakpoint'

export function MiniappTopbarContainer() {
  const fromTabletDisplay = useBreakpoint('sm')
  const topbar = useTopbar({
    isMobileDisplay: !fromTabletDisplay,
  })

  return <MiniappTopbar {...topbar} />
}
